<template>
  <div
    class="student-search-alert-error d-flex items-align-center"
    :class="customClasses"
  >
    <div class="w-100 text-left">
      <div v-if="message" class="d-inline">
        <em :class="iconClass" />
      </div>
      <p class="text-left d-inline" v-html="message" />
      <slot name="action-text" />
    </div>
  </div>
</template>

<style scoped>
.student-search-alert-error {
  background-color: #ffebeb;
  border: 1px solid #ff5b5c;
  padding: 10px;
  margin: 16px 0;
  border-radius: 4px;
  position: relative;
}
.student-search-alert-error.pl-0 {
  padding-left: 0;
}

.withoutspacing {
  margin-left: 0px;
  margin-right: 0px;
}

.student-search-alert-error p {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 0px;
  font-weight: normal;
}

.student-search-alert-error em {
  color: #ff5b5c;
  font-size: 18px;
  padding-right: 10px;
}

.student-search-alert-error.alert p,
.student-search-alert-error.alert em {
  color: #af6708;
}
.student-search-alert-error.alert {
  background: #fff5e8;
  border: 1px solid #fdac41;
}
.student-search-alert-error.no-border {
  border: none;
  background-color: transparent;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 5px;
}
.student-search-alert-error.no-border p {
  font-size: 14px;
}
.student-search-alert-error.no-border.pt-16 {
  padding-top: 16px;
}
.student-search-alert-error.no-icon {
  padding-left: 0;
}
.student-search-alert-error.no-icon em {
  display: none;
}
</style>

<script>
export default {
  name: 'Error',
  meta: {
    description: 'Componente personalizado para alertas de error.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    message: {
      type: String,
      default: '',
      meta: {
        description: 'Mensaje mostrado en el interior del componente',
        example: 'Texto requerido',
      },
    },
    icon: {
      type: String,
      default: '',
      meta: {
        description: 'Icono mostrado',
        example: 'fa-info-circle',
      },
    },
    isAlertMode: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Establece modo de alerta',
        example: 'true',
      },
    },
    variant: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para definir estilos',
        example: 'Texto requerido',
      },
    },
  },
  computed: {
    customClasses() {
      return this.isAlertMode ? 'alert ' + this.variant : this.variant;
    },
    iconClass() {
      let classes = 'fa ';
      if (this.icon?.length) classes += this.icon;
      else
        classes += this.isAlertMode ? 'fa-bell-exclamation' : 'fa-times-circle';

      return classes;
    },
  },
};
</script>
